var el;
var set = false;

var _set = function() {
	var pw;
	if (set) return;
	pw = document.getElementsByClassName('page-wrapper')[0];
	set = true;
	el.innerHTML = '* {outline:none}';
	pw.classList.add('no-outline');
}
var _remove = function() {
	var pw;
	if (!set) return;
	pw = document.getElementsByClassName('page-wrapper')[0];
	set = false;
	el.innerHTML = '';
	pw.classList.remove('no-outline');
}

var _init = function() {
	el = document.createElement('style');
	document.head.appendChild(el);

	_set();

	document.addEventListener('mousedown', _set);
	document.addEventListener('touchstart', _set);
	document.addEventListener('keydown', _remove);
}

_init();